import { saveServerLogs } from 'UtilityComponents/Util';
import { APPLICATION_CONSTANTS, PATHS } from 'AppConstants';
import { getccbAxiosConfig } from '../apisSetup/ccbConfig';

const ccbAxiosApiCaller = getccbAxiosConfig(true, {}, false);

export const queryFormApi = async (queryData) => {
	let response = null;
	try {
		response = await ccbAxiosApiCaller.post(PATHS.VENUES.SAVE_FORM, queryData);
	} catch (e) {
		const errorMsg = e ? e.message : APPLICATION_CONSTANTS.GENERIC_API_ERROR;
		response = { data: { message: errorMsg } };
		saveServerLogs(e.stack, 'error', PATHS.VENUES.SAVE_FORM);
	}
	return response;
};
